import { render } from "./ReviewRow.vue?vue&type=template&id=5bea4504"
import script from "./ReviewRow.vue?vue&type=script&lang=js"
export * from "./ReviewRow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__